import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientParentComponent } from './client-parent.component';

const routes: Routes = [{ path: '', component: ClientParentComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientParentRoutingModule { }
